export const deleteInformationLabel = {
  // incident module
  ehsIncidentDetails: [
    {
      label: "Incident",
      key: "incident",
      columns: [
        {
          header: "Incident ID",
          accessor: "incidentId",
          link: "/health-safety-and-environment/incident-management/report/view/",
        },
        { header: "Location Name", accessor: "siteName" },
        { header: "Incident Date", accessor: "incidentDate" },
        { header: "Incident Status", accessor: "incidentStatus" },
      ],
    },
    {
      label: "CAPA",
      key: "capa",
      columns: [
        {
          header: "CAPA ID",
          accessor: "capaId",
          link: "/health-safety-and-environment/capa-management/manage-capa/view/",
        },
        { header: "Source Type", accessor: "source" },
        { header: "CAPA Owner", accessor: "ownerName" },
        { header: "CAPA Status", accessor: "capaStatus" },
      ],
    },
  ],
  // vfl module
  ehs_vfls: [
    {
      label: "VFL",
      key: "vfl",
      columns: [
        {
          header: "VFL Id",
          accessor: "vflId",
          link: "/health-safety-and-environment/vfl/view/",
        },
        { header: "Location Name", accessor: "siteName" },
        { header: "Status", accessor: "vflStatus" },
      ],
    },
    {
      label: "CAPA",
      key: "capa",
      columns: [
        {
          header: "CAPA ID",
          accessor: "capaId",
          link: "/health-safety-and-environment/capa-management/manage-capa/view/",
        },
        { header: "Source Type", accessor: "source" },
        { header: "CAPA Owner", accessor: "ownerName" },
        { header: "CAPA Status", accessor: "capaStatus" },
      ],
    },
  ],
  // ohse module
  ehsEventSchedule: [
    {
      label: "OHSE",
      key: "ohse",
      columns: [
        {
          header: "OHSE Review ID",
          accessor: "scheduleId",
          link: "/health-safety-and-environment/audits-meetings/scheduled-event/meeting/view/",
        },
        { header: "Review Type", accessor: "meetingType" },
        { header: "Location Name", accessor: "siteName" },
        { header: "Status", accessor: "eventStatus" },
      ],
    },
    {
      label: "TASK",
      key: "task",
      columns: [
        {
          header: "Task ID",
          accessor: "taskId",
          link: "/health-safety-and-environment/audits-meetings/view-owner/",
        },
        { header: "Task Owner", accessor: "ownerName" },
        { header: "Status", accessor: "taskStatus" },
      ],
    },
  ],
  // capa module
  ehsCapa: [
    {
      label: "CAPA",
      key: "capa",
      columns: [
        {
          header: "CAPA ID",
          accessor: "capaId",
          link: "/health-safety-and-environment/capa-management/manage-capa/view/",
        },
        { header: "Source Type", accessor: "source" },
        { header: "CAPA Owner", accessor: "ownerName" },
        { header: "CAPA Status", accessor: "capaStatus" },
      ],
    },
  ],
  // task module
  ehs_meeting_tasks: [
    {
      label: "TASK",
      key: "task",
      columns: [
        {
          header: "Task ID",
          accessor: "taskId",
          link: "/health-safety-and-environment/audits-meetings/view-owner/",
        },
        { header: "Task Owner", accessor: "ownerName" },
        { header: "Status", accessor: "taskStatus" },
      ],
    },
  ],
  // training module
  ehsTrainingAssigners: [
    {
      label: "Training",
      key: "training",
      columns: [
        { header: "Staff Type", accessor: "staffType" },
        { header: "Name", accessor: "staffName" },
        { header: "Designation", accessor: "trainingDesignation" },
        { header: "Due Date", accessor: "dueDate" },
        { header: "Status", accessor: "trainingStatus" },
      ],
    },
  ],
  // medical module
  ehsMedicalAssigners: [
    {
      label: "Medical",
      key: "medical",
      columns: [
        { header: "Emp Type", accessor: "staffType" },
        { header: "Name", accessor: "staffName" },
        { header: "SME Category", accessor: "smeCategoryView" },
        { header: "Due Date", accessor: "dueDate" },
        { header: "Status", accessor: "medicalStatus" },
      ],
    },
  ],
};
